import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Card } from '../../../../model/card';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { CardsService } from '../../../../resources/cards/cards.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LimitsService } from '../../../../resources/limits/limits.service';
import { Limit } from '../../../../model/limit';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/first';
import { Location } from '@angular/common';
import { VehicleType } from '../../../../dictonaries/vehicle-type.enum';
import { enumToKeyValueArray } from '../../../../core/utils';
import 'rxjs/add/operator/do';
import { MzToastService } from 'ng2-materialize';
import { equalTo } from '../../../../core/validators';
import { isUndefined } from 'util';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { Vehicle } from '../../../../model/vehicle';
import { Driver } from '../../../../model/driver';
import { AgreementService } from '../../../../resources/agreement/agreement.service';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  providers: [Location]
})
export class CardComponent implements OnInit {

  card: Card;

  limits: Limit[];

  cardForm: FormGroup;

  types = [];

  id: number;

  card_type: string;

  cardTypes = [
    {
      id: 'D',
      name: 'kierowca'
    },
    {
      id: 'V',
      name: 'pojazd'
    },
    {
      id: 'C',
      name: 'kierowca/pojazd'
    },
    {
      id: 'B',
      name: 'okaziciel'
    }
  ];

  passwordErrorMessages = {
    areEqual: 'Kody PIN muszą się zgadzać. ',
    pattern: 'Kod musi składać się z 4 cyfr. ',
    required: 'To pole jest wymagane.'
  };

  agreement_type: number;

  constructor(private route: ActivatedRoute,
              private formBuilder: FormBuilder,
              private location: Location,
              private spinner: SpinnerService,
              private toast: MzToastService,
              private cdr: ChangeDetectorRef,
              private limitsService: LimitsService,
              private cardsService: CardsService,
              private agreement: AgreementService) {
  }

  ngOnInit() {
    this.types = enumToKeyValueArray(VehicleType);

    const limits$ = this.limitsService.query()
      .do((limits) => {
        this.limits = limits;
      });

    const params$ = this.route.params
      .do((params) => {
        this.id = +params.id;
      })
      .first();


    const card$ = params$
      .switchMap(() => {
        if (isNaN(this.id)) {
          return Observable.of(new Card());
        } else {
          return this.cardsService.get(this.id);
        }
      });


    limits$
      .switchMap(() => card$)
      .do((card) => {
        this.card = new Card(card);
        this.card.vehicle = new Vehicle(card.vehicle);
        this.card.driver = new Driver(card.driver);
      })
      .switchMap((card) => {
        if (card.card_no) {
          this.card_type = card.card_type;
          return Observable.of(card.card_no);
        } else {
          return Observable.of('zostanie ustalony przy wydaniu');
        }
      })
      .subscribe((card_no) => {
        this.card.card_no = card_no;
        this.buildForm();
        if (!isUndefined(this.card.id)) {
          this.onCardTypeChange(this.card.card_type);
          this.cardForm.markAsTouched();
          this.validateAllFormFields(this.cardForm);
        }
      });

    this.agreement_type = this.agreement.type;
  }

  onSubmit() {
    const request_value = JSON.parse(JSON.stringify(this.cardForm.value));
    request_value.card_no = this.cardForm.controls.card_no.value;
    if (request_value.driver_req == null) {
      request_value.driver_req = false;
    }

    if (request_value.car_no_req == null) {
      request_value.car_no_req = false;
    }
    const loading = this.spinner.show('Zapisuję...');
    let request;
    if (isUndefined(this.card.id)) {
      request = this.cardsService.create(request_value);
    } else {
      request = this.cardsService.update({ ...this.card, ...request_value } as Card);
    }
    request.subscribe((r) => {
        this.toast.show('Zapisano kartę', 2000, 'success');
        this.location.back();
      },
      (error) => {
        loading.close();
        this.toast.show(`Nie można zapisać karty. ${error}.`, 2000, 'error');
      });
  }

  back() {
    this.location.back();
  }

  generatePin() {
    const pin = [1,
      2,
      3,
      4].map(() => this.randomNumber())
      .join('');
    this.cardForm.controls['pin_code'].patchValue(pin);
    this.cardForm.controls['pin_code_repeat'].patchValue(pin);
  }

  resetPin() {
    let request;
    request = this.cardsService.resetPin(this.card.id);
    request.subscribe((r) => {
        this.toast.show('Zresetowano PIN', 2000, 'success');
        this.location.back();
      },
      (error) => {
        this.toast.show(`Nie można zresetować pinu. ${error}.`, 2000, 'error');
      });
  }

  onCardTypeChange(val) {
    const driver = this.cardForm.controls['driver']['controls']['name'];
    const vehicle = this.cardForm.controls['vehicle']['controls']['type'];
    const plate = this.cardForm.controls['vehicle']['controls']['plate'];
    this.card_type = val;
    switch (val) {
      case 'D':
        driver.setValidators([Validators.required]);
        vehicle.setValidators(null);
        plate.setValidators(null);
        break;
      case 'V':
        vehicle.setValidators([Validators.required]);
        plate.setValidators([Validators.required]);
        driver.setValidators(null);
        break;
      case 'C':
        vehicle.setValidators([Validators.required]);
        plate.setValidators([Validators.required]);
        driver.setValidators([Validators.required]);
        break;
      case 'B':
        vehicle.setValidators(null);
        plate.setValidators(null);
        driver.setValidators(null);
    }
    driver.updateValueAndValidity();
    vehicle.updateValueAndValidity();
    plate.updateValueAndValidity();
  }

  private randomNumber() {
    return Math.floor(Math.random()  * 9);
  }

  private buildForm() {
    this.cardForm = this.formBuilder.group({
      card_no: [{ value: this.card.card_no, disabled: true }],
      limit_id: [this.card.limit_id,
        Validators.compose([Validators.required])],
      pin_code: [this.card.pin_code,
        Validators.compose([
          equalTo('pin_code_repeat'),
          Validators.pattern(/^[\d]{4}$/)
        ])],
      pin_code_repeat: [this.card.pin_code,
        Validators.compose([
          equalTo('pin_code'),
          Validators.pattern(/^[\d]{4}$/)
        ])],
      card_type: [this.card.card_type,
        [Validators.required]],
      driver: this.formBuilder.group({
        name: [this.card.driver.name]
      }),
      vehicle: this.formBuilder.group({
        type: [this.card.vehicle.type,
          Validators.compose([Validators.required])],
        plate: [this.card.vehicle.plate]
      }),

      driver_req: [this.card.driver_req],
      car_no_req: [this.card.car_no_req],
      odometer_req: [this.card.odometer_req],
      mpk_req: [this.card.mpk_req],
    });

    if (this.agreement_type === 3) {
      this.cardForm.get('limit_id').setValidators(null);
      this.cardForm.get('limit_id').updateValueAndValidity();
    }

  }

  private validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
        control.markAsDirty({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/forms/card/card.component.ts